import { cn } from '@rocco/utils/cn';

/**
 * Tailwind CSS classes for rich text for different HTML elements.
 */
const RICH_TEXT_CLASSES = {
    a: '[&_a:hover]:text-black [&_a]:underline',
    p: '[&_p]:mb-4',
    ul: '[&_ul]:mb-4 [&_ul]:pl-8 [&_ul]:list-disc',
    menu: '[&_menu]:mb-4 [&_menu]:pl-8 [&_menu]:list-disc',
    ol: '[&_ol]:mb-4 [&_ol]:pl-8 [&_ol]:list-decimal',
};

/**
 * The more compact version of the rich text classes above. The spacing values
 * are smaller.
 */
const RICH_TEXT_COMPACT_CLASSES = {
    a: '[&_a:hover]:text-black [&_a]:underline',
    p: '[&_p]:mb-1 [&_p:last-child]:mb-0',
    ul: '[&_ul]:mb-1 [&_ul:last-child]:mb-0 [&_ul]:pl-4 [&_ul]:list-disc',
    menu: '[&_menu]:mb-1 [&_menu:last-child]:mb-0 [&_menu]:pl-4 [&_menu]:list-disc',
    ol: '[&_ol]:mb-1 [&_ol:last-child]:mb-0 [&_ol]:pl-4 [&_ol]:list-decimal',
};

/**
 * Tailwind CSS classes for rich text. Use this for displaying information
 * text or page builder modules.
 */
export const RICH_TEXT_CLASS = cn(
    RICH_TEXT_CLASSES.a,
    RICH_TEXT_CLASSES.p,
    RICH_TEXT_CLASSES.ul,
    RICH_TEXT_CLASSES.menu,
    RICH_TEXT_CLASSES.ol,
);

/**
 * Tailwind CSS classes for rich text. This is the compact version. Use this
 * for displaying rich text in chat messages.
 */
export const RICH_TEXT_COMPACT_CLASS = cn(
    RICH_TEXT_COMPACT_CLASSES.a,
    RICH_TEXT_COMPACT_CLASSES.p,
    RICH_TEXT_COMPACT_CLASSES.ul,
    RICH_TEXT_COMPACT_CLASSES.menu,
    RICH_TEXT_COMPACT_CLASSES.ol,
);
